import { Component, ErrorInfo, ReactNode } from 'react';
import * as Sentry from '@sentry/react';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

export class GlobalErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        error: null,
    };

    public static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('Uncaught error:', error, errorInfo);
        Sentry.captureException(error, {
            contexts: {
                react: { componentStack: errorInfo.componentStack },
            },
        });
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    fontFamily: 'system-ui, sans-serif',
                    padding: '2rem',
                    backgroundColor: '#fff1f2'
                }}>
                    <div style={{
                        maxWidth: '600px',
                        width: '100%',
                        backgroundColor: 'white',
                        padding: '2rem',
                        borderRadius: '0.5rem',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                        border: '1px solid #fecaca'
                    }}>
                        <h1 style={{ color: '#e11d48', marginTop: 0 }}>Application Error (Platform)</h1>
                        <p style={{ color: '#374151' }}>Something went wrong while initializing the application.</p>
                        <div style={{
                            marginTop: '1rem',
                            padding: '1rem',
                            backgroundColor: '#fff5f5',
                            borderRadius: '0.375rem',
                            overflow: 'auto',
                            maxHeight: '300px'
                        }}>
                            <code style={{ fontSize: '0.875rem', color: '#881337' }}>
                                {this.state.error?.toString()}
                            </code>
                        </div>
                        <button
                            onClick={() => window.location.reload()}
                            style={{
                                marginTop: '1.5rem',
                                padding: '0.5rem 1rem',
                                backgroundColor: '#e11d48',
                                color: 'white',
                                border: 'none',
                                borderRadius: '0.375rem',
                                cursor: 'pointer',
                                fontSize: '0.875rem',
                                fontWeight: 500
                            }}
                        >
                            Reload Application
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
